export default {
  LongOperationStarted: 'LONG_OPERATION_STARTED',
  LongOperationCompleted: 'LONG_OPERATION_COMPLETED',

  OpenInformationDialog: 'OPEN_INFORMATION_DIALOG',
  CloseInformationDialog: 'CLOSE_INFORMATION_DIALOG',
  OpenConfirmationDialog: 'Open_CONFIRMATION_DIALOG',
  CloseConfirmationDialog: 'CLOSE_CONFIRMATION_DIALOG'
}
